import { Button } from 'antd';
import React from 'react';
import { dolarMask } from '../../library/helpers/moneyMask';
import IntlMessages from "@iso/components/utility/intlMessages";

function PayButton({ value = 0, disabled, onClick, loading }) {
  return (
    <Button
      shape="round"
      type="primary"
      disabled={value === 0 || disabled || loading}
      size='large'
      onClick={onClick}
      loading={loading}
      className='border-0 text-white !text-xl items-center text-center shadow-none w-full  bg-primary'>
      <IntlMessages id="page.my_account.financial.pay" /> {dolarMask(value)}
    </Button>
  );
}

export default PayButton; 